import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getAccessToken();
  if (!token) {
    router.navigate(['/auth/login']);
    return false;
  }

  if (!authService.hasValidSession()) {
    authService.clearSession();
    router.navigate(['/auth/login']);
    return false;
  }

  if (!authService.isAccessTokenExpired()) {
    return true;
  }

  if (!authService.getRefreshToken()) {
    authService.clearSession();
    router.navigate(['/auth/login']);
    return false;
  }

  return authService.refreshSession().pipe(
    map(() => true),
    catchError(() => {
      authService.clearSession();
      router.navigate(['/auth/login']);
      return of(false);
    }),
  );
};
